/**
 * Global discount-code modal controller.
 *
 * Pairs with snippets/discount-code-modal.liquid (rendered once from
 * layout/theme.liquid). Exposes window.openDiscountModal() so any page
 * can prompt the visitor to claim a discount code by phone number.
 *
 * Backend endpoints, payload shape and discount codes mirror the in-flow
 * implementation in assets/explore.js so a signup from the promo bar
 * lands in the same DynamoDB tables.
 */
(function () {
  'use strict';

  var API_BASE = 'https://isnjz3kdxk.execute-api.us-east-1.amazonaws.com/prod';
  var API_KEY = 'gmkxBXr02VaPXOhdX79Ywa9RkG7TvViO1FGUSd58';
  var DISCOUNT_CODE = 'WOOF50';

  function $(id) {
    return document.getElementById(id);
  }

  function showModal(modal) {
    if (!modal) return;
    modal.classList.remove('d-none');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function hideModal(modal) {
    if (!modal) return;
    modal.classList.add('d-none');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function openDiscountModal() {
    var modal = $('globalDiscountCodeModal');
    if (!modal) return;
    showModal(modal);
    setTimeout(function () {
      var phoneInput = $('globalDiscountPhone');
      if (phoneInput) phoneInput.focus();
    }, 100);
  }

  function closeDiscountModal() {
    var modal = $('globalDiscountCodeModal');
    hideModal(modal);
    var phoneInput = $('globalDiscountPhone');
    if (phoneInput) phoneInput.value = '';
  }

  function showConfirmation(code) {
    var modal = $('globalDiscountConfirmationModal');
    var display = $('globalDiscountCodeDisplay');
    if (display) display.textContent = code;
    showModal(modal);
  }

  function closeConfirmation() {
    hideModal($('globalDiscountConfirmationModal'));
  }

  async function postJson(path, payload) {
    try {
      var response = await fetch(API_BASE + path, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': API_KEY,
        },
        body: JSON.stringify(payload),
      });
      var result = await response.json();
      var body = typeof result.body === 'string' ? JSON.parse(result.body) : result;
      if (!response.ok) {
        console.error('Discount modal API error (' + path + '):', body && body.message ? body.message : 'Unknown error');
        return false;
      }
      return true;
    } catch (err) {
      console.error('Discount modal API request failed (' + path + '):', err);
      return false;
    }
  }

  async function storeDiscountSignup(data) {
    return postJson('/store-discount-signup', data);
  }

  async function storeLeadToMasterList(phone, dogName, parentName) {
    var payload = {
      dog_name: dogName || '',
      parent_name: parentName || '',
      opt_out: false,
      campaign_type: [],
      source: 'Discount Code Signup',
    };
    if (phone) payload.phone_number = phone;
    return postJson('/crm/master-list', payload);
  }

  // Pulls any meal-plan context that happens to be on the page (only the
  // explore page has these fields). On other pages this returns nulls.
  function collectContext() {
    if (typeof window.collectPricingStepData === 'function') {
      try {
        return window.collectPricingStepData() || {};
      } catch (err) {
        console.warn('collectPricingStepData threw:', err);
      }
    }
    var byId = function (id) {
      var el = $(id);
      return el && el.value ? el.value : null;
    };
    return {
      dog_age: byId('dogAge'),
      dog_weight: byId('dogWeight'),
      dog_breed: byId('dogBreedFinal'),
      activity_level: (document.querySelector('input[name="activityLevel"]:checked') || {}).value || null,
      fixed_or_not: (document.querySelector('input[name="fixedOrNot"]:checked') || {}).value || null,
      treat_quantity: (document.querySelector('input[name="treatQuantity"]:checked') || {}).value || null,
      calculated_calories: ($('calculatedCalories') || {}).textContent || null,
      zip_code: null,
    };
  }

  function applyCodeToExplorePage(code) {
    var pageInput = $('discountCodeInput');
    var modalInput = $('discountCode');
    if (pageInput) {
      pageInput.value = code;
      pageInput.removeAttribute('readonly');
      pageInput.removeAttribute('disabled');
    }
    if (modalInput) {
      modalInput.value = code;
      modalInput.removeAttribute('readonly');
      modalInput.removeAttribute('disabled');
    }
    if (typeof window.validateDiscountCode === 'function') {
      try {
        window.validateDiscountCode(code);
      } catch (err) {
        console.warn('validateDiscountCode threw:', err);
      }
    }
  }

  async function handleSubmit() {
    var phoneInput = $('globalDiscountPhone');
    var phone = phoneInput ? phoneInput.value.trim().replace(/\D/g, '') : '';

    if (!phone || phone.length !== 10) {
      alert('Please enter a valid 10-digit phone number');
      if (phoneInput) phoneInput.focus();
      return;
    }

    var dogName = (($('dogName') || {}).value || '').trim();
    var parentName = (($('parentName') || {}).value || '').trim();

    await storeLeadToMasterList(phone, dogName, parentName);

    var signupData = Object.assign({}, collectContext(), {
      phone: phone,
      dog_name: dogName,
      discount_code: DISCOUNT_CODE,
      discount_type: 'phone',
    });
    await storeDiscountSignup(signupData);

    try {
      localStorage.setItem('discountPhone', phone);
    } catch (err) {
      // Ignore storage errors (private mode, etc.)
    }

    applyCodeToExplorePage(DISCOUNT_CODE);
    closeDiscountModal();
    setTimeout(function () {
      showConfirmation(DISCOUNT_CODE);
    }, 300);
  }

  function bindCloseHandlers(modal, onClose) {
    if (!modal) return;
    var overlay = modal.querySelector('.discount-modal-overlay');
    var content = modal.querySelector('.discount-modal-content');
    if (overlay) overlay.addEventListener('click', onClose);
    if (content) {
      content.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }
  }

  function init() {
    var modal = $('globalDiscountCodeModal');
    if (!modal) return; // Snippet not on page.

    var closeBtn = $('closeGlobalDiscountModal');
    if (closeBtn) closeBtn.addEventListener('click', closeDiscountModal);
    bindCloseHandlers(modal, closeDiscountModal);

    var confirmModal = $('globalDiscountConfirmationModal');
    var closeConfirmBtn = $('closeGlobalDiscountConfirmationModal');
    var gotItBtn = $('closeGlobalDiscountConfirmationBtn');
    if (closeConfirmBtn) closeConfirmBtn.addEventListener('click', closeConfirmation);
    if (gotItBtn) gotItBtn.addEventListener('click', closeConfirmation);
    bindCloseHandlers(confirmModal, closeConfirmation);

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (!modal.classList.contains('d-none')) closeDiscountModal();
      if (confirmModal && !confirmModal.classList.contains('d-none')) closeConfirmation();
    });

    var phoneInput = $('globalDiscountPhone');
    if (phoneInput) {
      phoneInput.addEventListener('input', function (e) {
        var value = e.target.value.replace(/\D/g, '');
        if (value.length > 10) value = value.slice(0, 10);
        e.target.value = value;
      });
    }

    var submitBtn = $('getGlobalDiscount');
    if (submitBtn) submitBtn.addEventListener('click', handleSubmit);

    if (phoneInput) {
      phoneInput.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        handleSubmit();
      });
    }

    // Delegate clicks for any element marked as a trigger.
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-discount-modal-trigger]');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      openDiscountModal();
    });

    // Keyboard activation for non-button triggers (e.g. <span role="button">).
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var trigger = e.target.closest && e.target.closest('[data-discount-modal-trigger]');
      if (!trigger) return;
      if (trigger.tagName === 'BUTTON') return; // Browser handles native buttons.
      e.preventDefault();
      e.stopPropagation();
      openDiscountModal();
    });
  }

  // Expose the opener globally so any inline handler / other script can use it.
  window.openDiscountModal = openDiscountModal;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
